import type { JSX } from 'react'
import HtmlToReact from 'html-to-react'
const HtmlToReactParser = (
   HtmlToReact as {
      Parser: () => {
         parseWithInstructions: (
            content: string,
            shouldProcessNode: () => boolean,
            processingInstructions: unknown[]
         ) => JSX.Element
      }
   }
).Parser

const processNodeDefinitions = HtmlToReact.ProcessNodeDefinitions()
const processingInstructions = [
   {
      shouldProcessNode: () => true,
      processNode: processNodeDefinitions.processDefaultNode,
   },
]

export const convertWpHtmlToJsx = (content: string): JSX.Element => {
   const htmlToReactParser = HtmlToReactParser()
   const reactElement = htmlToReactParser.parseWithInstructions(
      content,
      () => true,
      processingInstructions
   )

   return reactElement
}
